module.exports = __webpack_public_path__ + "img/spark-m.96d06404.png";